import React from 'react';
import { Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useTheme } from '@mui/material/styles';

const SearchInput = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  width = 280,
  fullWidth = false,
  height,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: isDark ? '#242424' : '#f7fafc',
        borderRadius: '8px',
        px: 2,
        py: height ? 0 : 0.75,
        height: height || 'auto',
        minHeight: height ? height : 44,
        width: fullWidth ? '100%' : { xs: '100%', sm: width },
        maxWidth: fullWidth ? '100%' : { xs: '100%', sm: width },
        transition: 'all 0.2s ease',
        border: isDark ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid #e2e8f0',
        '&:focus-within': {
          backgroundColor: isDark ? '#1a1a1a' : '#ffffff',
          border: isDark ? '1px solid #6366f1' : '1px solid #1976d2',
          boxShadow: isDark
            ? '0 0 0 3px rgba(99, 102, 241, 0.1)'
            : '0 0 0 3px rgba(25, 118, 210, 0.1)',
        },
      }}
    >
      <SearchIcon
        sx={{
          color: isDark ? '#718096' : '#cbd5e1',
          fontSize: 20,
          mr: 1,
        }}
      />
      <InputBase
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        sx={{
          flex: 1,
          fontSize: '0.875rem',
          color: isDark ? '#ffffff' : '#1a202c',
          '& input': {
            padding: 0,
          },
          '& input::placeholder': {
            color: isDark ? '#718096' : '#cbd5e1',
            opacity: 1,
          },
        }}
      />
      {value && onClear && (
        <Box
          onClick={onClear}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            ml: 1,
            p: 0.25,
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: isDark ? 'rgba(255, 255, 255, 0.1)' : '#e2e8f0',
            },
          }}
        >
          <ClearIcon sx={{ fontSize: 16, color: isDark ? '#64748b' : '#7c8fac' }} />
        </Box>
      )}
    </Box>
  );
};

export default SearchInput;
